import { TraceManager } from './trace-manager';
import { Trace } from './trace';
import { Span } from './span';

// 导出类型
export * from './types';

// 导出类
export { TraceManager } from './trace-manager';
export { Trace } from './trace';
export { Span } from './span';
export { Reporter } from './reporter';
export { Executor } from './executor';

// 创建全局实例
const traceManager = new TraceManager();
const globalExecutor = traceManager.getExecutor();

// 挂载到 window 对象
export const mountTraceManager = () => {
  if (typeof window !== 'undefined') {
    (window as any).traceManager = traceManager;
    (window as any).executor = globalExecutor;
  }
};

// 初始化函数
const initializeTraceManager = () => {
  const traceConfig = (window as any).TraceConfig;
  if (traceConfig) {
    try {
      traceManager.init(traceConfig);
      if (traceConfig.debug) {
        console.log('TraceManager initialized from window.TraceConfig:', traceConfig);
      }
      return true;
    } catch (error) {
      console.error('Failed to initialize TraceManager:', error);
      return false;
    }
  }
  return false;
};

// 自动挂载并初始化（在模块加载时执行）
if (typeof window !== 'undefined') {
  (window as any).traceManager = traceManager;
  (window as any).executor = globalExecutor;

  // 立即尝试初始化
  if (!initializeTraceManager()) {
    // 如果初始化失败，等待 DOM 加载完成后再试
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => {
        if (!initializeTraceManager()) {
          console.warn('window.TraceConfig not found after DOMContentLoaded, TraceManager not initialized');
        }
      });
    } else {
      // DOM 已经加载完成，但配置仍然不存在
      console.warn('window.TraceConfig not found, TraceManager not initialized');
    }
  }
}

// 默认导出
export default traceManager;

